import React, { useState, useEffect } from "react";
import CustomDrawer from "../../controls/CustomDrawer";
import Input from "../../controls/Input";
import { toast } from "react-toastify";
import Loading from "../../controls/Loading";
import { useSelector } from "react-redux";
import { handleAddTable, handleUpdateTable } from "../../../api/KOTApi";

const AddTable = ({ closeDrawer, onSuccess, editData = {} }) => {

  const store = useSelector((state) => state.store.store);

  const [table, setTable] = useState("");
  const [sequence, setSequence] = useState("");
  const [tableError, setTableError] = useState("");
  const [sequenceError, setSequenceError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editData && Object.keys(editData).length > 0) {
      setTable(editData?.Table || "");
      setSequence(editData?.SequenceNo || "");
    }
  }, [editData]);

  const handleSaveClick = async () => {

    if (!table.trim()) {
      setTableError("Please enter table");
      return;
    }

    if (sequence === "" || sequence === null) {
      setSequenceError("Please enter sequence");
      return;
    }

    const payload = {
      StoreID: store?.key,
      Table: table.trim(),
      SequenceNo: Number(sequence),
      IsDeleted: false
    };

    setLoading(true);

    try {

      let response;

      if (editData?.key) {
        response = await handleUpdateTable(payload,editData?.key);
      } else {
        response = await handleAddTable(payload);
      }

      if (response?.code === "0") {

        toast.success(
          editData?.key
            ? "Table updated successfully"
            : "Table added successfully"
        );

        onSuccess?.();
        closeDrawer?.();

      } else {
        toast.error(response?.message || "Failed to save table");
      }

    } catch (error) {

      toast.error(
        error?.response?.data?.message ||
        error?.message ||
        "Unexpected error occurred"
      );

    } finally {
      setLoading(false);
    }
  };

  return (
    <CustomDrawer
      setDrawer={closeDrawer}
      drawerWidth="sm:w-[500px]"
      title={editData?.key ? "Edit Table" : "Add Table"}
      buttons={[
        { Label: "Cancel", Type: "secondary", Icon: "roundedRemove" },
        { Label: "Save", Type: "primary", Icon: "save" },
      ]}
      onButtonClick={(label) => {
        if (label === "Save") handleSaveClick();
        if (label === "Cancel") closeDrawer();
      }}
    >
      {loading ? (
        <Loading />
      ) : (
        <>
          <Input
            isMandatory={true}
            label="Table"
            placeholder="Table"
            type="text"
            value={table}
            onChange={(e) => {
              setTable(e.target.value);
              setTableError("");
            }}
            errorMessage={tableError}
          />

          <Input
            label="Sequence"
            type="number"
            value={sequence}
            onChange={(e) => {
              setSequence(e.target.value);
              setSequenceError("");
            }}
            errorMessage={sequenceError}
          />
        </>
      )}
    </CustomDrawer>
  );
};

export default AddTable;